import React, { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import capitalizeFirstLetter from '../../../_shared/utils/capitalizeFirstLetter';
import {
  TradeState,
  TradeContextName,
  context as primaryContext
} from '../../../_shared/types/trade';
import ROUTES from '../../Routes/constants';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import useAnalytics from '../../../_shared/hooks/useAnalytics';
import {
  expireCookie,
  createCookie,
  getCookie
} from '../../../_shared/utils/cookies';
import { COOKIES } from '../../../_shared/constants/cookies';
import Divider from '../Divider';

import { StyledFooter, FooterButton } from './Styles';

const Footer = ({ tradeContext, tradeState }) => {
  const track = useAnalytics();
  const history = useHistory();
  const intl = useIntl();
  const [tradeStateName, setTradeStateName] = useState(
    TradeState?.[tradeState] || undefined
  );
  const target = '_self';

  // expire cookie set by TR4
  const deletCookieTR4 = useCallback(() => {
    // expire cookie set by TR4
    expireCookie(COOKIES.LIST_PARAMS);
  }, []);

  // create a new cookie for TR4 containing the url params
  // neccessary for scroll restoration when the user clicks
  // back to active/upcoming
  const setCookieForTR4 = () => {
    const listCookie = getCookie(COOKIES.LIST_PARAMS);

    if (listCookie) {
      createCookie(COOKIES.LIST_PARAMS5, listCookie);
    }
  };

  useEffect(() => {
    window.addEventListener('beforeunload', deletCookieTR4);

    return () => {
      window.removeEventListener('beforeunload', deletCookieTR4);
    };
  });

  const goBackTo = () => {
    track(MixpanelConfig.names.backToListViewFromVDP, {
      trade_state: tradeStateName,
      trade_state_section: TradeContextName[tradeContext]
    });

    setCookieForTR4();
    const routing = {
      [primaryContext.buying]: {
        [TradeState.pending]: () => history.push(`${ROUTES.BUYING_PENDING}`),
        [TradeState.closing]: () => history.push(`${ROUTES.BUYING_PENDING}`),
        [TradeState.upcoming]: () =>
          window.open(`${ROUTES.TR4_BUY_UPCOMING}`, target),
        [TradeState.active]: () =>
          window.open(`${ROUTES.TR4_BUY_ACTIVE}`, target)
      },
      [primaryContext.selling]: {
        [TradeState.pending]: () => history.push(`${ROUTES.SELLING_PENDING}`),
        [TradeState.closing]: () => history.push(`${ROUTES.SELLING_CLOSING}`),
        [TradeState.active]: () =>
          window.open(`${ROUTES.TR4_SELL_ACTIVE}`, target)
      }
    };

    if (routing[tradeContext]?.[tradeState]) {
      routing[tradeContext]?.[tradeState]();
    }
  };

  const [visibility, setVisibility] = useState(false);
  useEffect(() => {
    let newVisibility = false;
    if (primaryContext.buying === tradeContext) {
      // Buying Visibility
      newVisibility = [
        TradeState.upcoming,
        TradeState.active,
        TradeState.pending,
        TradeState.closing
      ].includes(tradeState);
    } else if (primaryContext.selling === tradeContext) {
      // Seller visibility
      newVisibility = [TradeState.pending, TradeState.closing].includes(
        tradeState
      );
    }
    setTradeStateName(TradeState[tradeState]);
    setVisibility(newVisibility);
  }, [tradeContext, tradeState]);

  return (
    <StyledFooter>
      {visibility && tradeStateName && (
        <>
          <Divider
            text={intl.formatMessage(
              {
                id: 'vdp.footer.findMore'
              },
              {
                tradeState: capitalizeFirstLetter(
                  intl.formatMessage({
                    id: `tradeState.${tradeStateName.toLowerCase()}`
                  })
                )
              }
            )}
          />
          <FooterButton onClick={goBackTo}>
            {/* BACK TO {tradeState} */}
            <FormattedMessage
              id="vdp.footer.backTo"
              values={{
                tradeState: intl.formatMessage({
                  id: `tradeState.${tradeStateName.toLowerCase()}`
                })
              }}
            />
          </FooterButton>
        </>
      )}
    </StyledFooter>
  );
};

export default Footer;
